<script setup>
// Imports
import { DateTime } from 'luxon'
import { usePageLoading } from 'src/composables/usePageLoading'

// Props
const props = defineProps({
  updatedAt: { type: [String, Number, Date], default: null },
  refresh: { type: Function, default: null },
  loading: { type: Boolean, default: false },
  disableRefresh: { type: Boolean, default: false },
})

// Constants
const { locale } = useI18n({ useScope: 'global' })
usePageLoading(() => props.loading)

// Computed
const updatedTime = computed(() => {
  if (!props.updatedAt) return null
  const date = DateTime.fromJSDate(new Date(props.updatedAt)).setLocale(locale.value).setZone('Europe/Amsterdam')
  return date.isValid ? date.toFormat('dd LLL yyyy, HH:mm:ss') : null
})
</script>

<template>
  <!-- Page actions and successful refresh time -->
  <header v-if="updatedTime || refresh || $slots.actions" class="omni-page-header row items-center justify-end q-mb-sm">
    <span v-if="updatedTime" class="text-body1 omni-updated-time">{{ $t('Shared.Globals.Data updated at', { time: updatedTime }) }}</span>
    <slot name="actions" />
    <q-btn
      v-if="refresh"
      dense
      flat
      no-caps
      icon="refresh"
      :label="$q.screen.xs ? undefined : $t('Shared.Globals.Refresh')"
      :aria-label="$t('Shared.Globals.Refresh')"
      :disable="loading || disableRefresh"
      @click="refresh()"
    />
  </header>
</template>
